<template>
  <div>
    <van-cell
      v-if="isNormalStyle"
      class="ry-form__data-source"
      @click="openSelect">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{content}}
        </div>
        <div v-else-if="!isRead">
          <div class="ry-form__dropdown-input">

            <div
              :key="itemKey"
              class="select-item"
              v-if="currentRow[dataId] && currentRow[dataId].length">
              <template v-if="current.chooseType">
                <van-tag
                  v-for="(item, idx) in currentRow[dataId]"
                  closeable
                  size="medium"
                  @close="removeItem(idx)">
                  {{item}}
                </van-tag>
              </template>
              <div v-else style="color: #000000">
                {{currentRow[dataId]}}
              </div>
              <van-icon
                v-if="!current.chooseType && currentRow[dataId]"
                name="close"
                class="close-btn"
                @click.stop="clearData">
              </van-icon>
            </div>

            <span v-else>
            {{current.fieldDes}}
          </span>
          </div>
        </div>

      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__data-source-compact">

      <van-field
        v-if="isRead"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div>
            {{content}}
          </div>
        </template>
      </van-field>

      <van-field
        v-else
        :label="current.title"
        :label-class="{'readonly-field-label': isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div class="ry-form__data-source-container"  @click="openSelect">
            <div class="ry-form__dropdown-input" style="padding: 0;">

              <div
                class="select-item"
                v-if="currentRow[dataId] && currentRow[dataId].length">
                <template v-if="current.chooseType">
                  <van-tag
                    v-for="(item, idx) in currentRow[dataId]"
                    closeable
                    size="medium"
                    @close="removeItem(idx)">
                    {{item}}
                  </van-tag>
                </template>
                <div v-else style="color: #333333; margin-left: -10px;">
                  {{currentRow[dataId] }}
                </div>
                <van-icon
                  v-if="!current.chooseType && currentRow[dataId] && !isReadOnly"
                  name="close"
                  style="right: 0;"
                  class="close-btn"
                  @click.stop="clearData">
                </van-icon>
              </div>

              <span v-else style="color: #bbbec4;">
                {{current.fieldDes || isReadOnly ? '暂无内容' : '请选择'}}
              </span>
            </div>
          </div>
        </template>
      </van-field>
    </div>

    <RySelectPopup
      ref="dsSelectPopup"
      :title="current.title"
      :is-add-btn="Boolean(current.allowAddData && hasFillForm && !$route.path.includes('/link/posting'))"
      :relateFormName="relateFormName"
      :relateAppId="current.relateAppId"
      :relateFormId="current.relateFormId"
      :memberShowType="current.showNameOnly === 'YES' ? 'NAME' : 'IMAGE'"
      :remoteSearch="true"
      :refreshData="refreshData"
      @selectComplete="onSelect">
    </RySelectPopup>

    <RySelectPopup
      v-if="current.pluginConfig && current.pluginConfig.entryId"
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>
  </div>

</template>

<script>
  import { current } from './mixin'
  import {FORM_ITEM__IMAGE} from "../../types";

  export default {
    mixins: [current],
    inject: ['hasFillFormMap', 'relateFormNameMap'],
    data () {
      return {
        itemKey: Math.random(),
        dataOrigin: {
          init: false,
          dataList: [],
          currentPage: 1,
          pageSize: 200,
          totalPage: 0,
          totalCount: 0
        },
        isSelectFirst: false,
        loading: false
      }
    },
    computed: {
      hasFillForm() {
        return this.hasFillFormMap[this.current.dataId]
      },
      relateFormName() {
        return this.relateFormNameMap[this.current.dataId]
      },
      content() {
        return this.currentRow[this.current.dataId] ? (this.current.chooseType ? (this.currentRow[this.current.dataId] || []).join('、') : this.currentRow[this.current.dataId]) : '暂无内容'
      },
    },
    created() {
      // 获取权限
      // this.$store.dispatch('actionFormFillPermission', {
      //   appId: this.current.relateAppId,
      //   formId: this.current.relateFormId,
      // }).then(res => {
      //   this.hasFillForm = res.hasPer
      // }).catch(console.error)
      //
      // if (this.current.relateAppId && this.current.relateFormId) {
      //   this.$store.dispatch('actionLiteMergeStructure', {
      //     appId: this.current.relateAppId,
      //     formId: this.current.relateFormId,
      //   })
      //     .then(resultObject => {
      //       this.relateFormName = resultObject.detailInfo.formName
      //     })
      //     .catch(console.error)
      // }
    },
    methods: {
      onSelect (selectList) {
        if (!selectList || !selectList.length) {
          this.currentRow[this.current.dataId] = ''
          this.controlChange()
          this.submitData()
          return
        }
        const item = selectList[0].item
        if (this.current.chooseType) {
          if (!this.currentRow[this.dataId]) {
            this.currentRow[this.dataId] = []
          }
          const val = this.currentRow[this.dataId]
          if (this.currentRow[this.dataId].includes(item.mainValue)) {
            val.splice(val.indexOf(item.mainValue), 1)
          } else {
            this.currentRow[this.dataId].push(item.mainValue)
          }
        } else {
          this.currentRow[this.dataId] = item.mainValue
        }
        // 设置其他控件值
        this.current.chooseChangeFields.forEach(opt => {
          const value = item.otherValueMap[opt.localFieldId]
          this.currentRow[opt.localFieldId] = value
        })
        this.controlChange()
        this.submitData()
      },
      clearData() {
        this.currentRow[this.dataId] = ''
        this.itemKey = Math.random()
        this.controlChange()
        this.submitData()
      },
      async openSelect () {
        if (this.isReadOnly || this.isRead) return
        this.visibleChange()
      },
      // 刷新数据源
      refreshData() {
        this.isSelectFirst = true
        this.visibleChange()
      },
      visibleChange () {

        if (this.isReadOnly) {
          return
        }

        const formSet = this.current.root

        if (this.$refs.dsSelectPopup) {
          this.$refs.dsSelectPopup.open({
            companyId: formSet.companyId,
            appId: formSet.appId,
            formId: formSet.formId,
            data: formSet.getValues(),
            rowIdx: this.index + 1,
            relateFieldId:this.current.relateFieldId,
            currentDataId: this.current.dataId
          })
        }
        // if (!this.dataOrigin.init) {
          const toast = this.$toast.loading({ message: '加载中...' })
          return this.$store.dispatch('actionExternalData', {
            companyId: formSet.companyId,
            appId: formSet.appId,
            formId: formSet.formId,
            fieldId: this.current.dataId,
            data: formSet.getValues(),
            rowIdx: this.index + 1,
            queryStr: this.currentRow[this.current.dataId],
            currentPage: this.dataOrigin.currentPage,
            pageSize: this.dataOrigin.pageSize
          }).then(({ dataList, chooseValue, currentPage, pageSize, totalPage, totalCount, fieldList}) => {

            if (chooseValue.length) {
              const isExist = dataList.some(item => item.mainValue === chooseValue[0].mainValue)
              if (!isExist) {
                dataList.push(...chooseValue)
              }
            }
            let showDataList = []
            dataList.forEach((item, idx) => {
              let showData = {
                title: {},
                image: {},
                content: [],
                item,
                instanceId: idx
              }
              showData.title = {
                showData: item.mainValue,
                fieldId: this.current.relateFieldId,
                type: 'title'
              }

              const imageArr = []
              const contentArr = []
              item.subValue.forEach(subV => {
                const field = fieldList.filter(d => d.dataId === subV.fieldId)[0]
                if (field) {
                  if (field.type === FORM_ITEM__IMAGE) {
                    imageArr.push({
                      showData: subV.value && subV.value.length > 0 ? subV.value[0].imgUrl : '',
                      fieldId: field.dataId,
                      type: 'title'
                    })
                  } else {
                    contentArr.push({
                      showData: subV.value,
                      type: field.type,
                      ...field
                    })
                  }
                }
              })
              showData.image = imageArr.length > 0 ? imageArr[0] : {}
              showData.content = contentArr.slice(0, 4)
              showDataList.push(showData)
            })
            if (this.$refs.dsSelectPopup) {
              this.$refs.dsSelectPopup.setDataList(showDataList)
              const selectList = showDataList.filter(item => item.item.mainValue === this.currentRow[this.current.dataId])

              if (this.isSelectFirst) {
                if(showDataList && showDataList.length) this.$refs.dsSelectPopup.addSelectList([showDataList[0]])
              } else {
                this.$refs.dsSelectPopup.addSelectList(selectList)
              }
              this.isSelectFirst = false
            }

            this.dataOrigin.dataList.splice(0, this.dataOrigin.dataList.length, ...showDataList)
            this.dataOrigin.currentPage = currentPage
            this.dataOrigin.pageSize = pageSize
            this.dataOrigin.totalPage = totalPage
            this.dataOrigin.totalCount = totalCount
          }).catch(err => {
            console.error(err)
          }).finally(() => {
            this.dataOrigin.init = true
            toast.clear()
          })
        // }
      },
      removeItem (idx) {
        this.currentRow[this.dataId].splice(idx, 1)
      }
    },
    components: {},
    watch: {}
  }
</script>
